import { CheckIcon } from "./icons";
import { resolveImage } from "../data/assetMap";

export default function BankGrid({ banks, fins, onToggle, disabled, max }) {
  // Once the cap is reached, the unselected tiles are dimmed but stay
  // clickable so onToggle can tell the user they can't pick more.
  const atCap = max != null && Object.values(fins || {}).filter(Boolean).length >= max;
  return (
    <div className="bank-grid">
      {(banks || []).map((b) => {
        const on = !!fins[b.key];
        const logoUrl = resolveImage(b.logo);
        return (
          <button
            key={b.key}
            type="button"
            className={"bank-tile" + (on ? " bank-tile--on" : "") + (atCap && !on ? " bank-tile--capped" : "")}
            disabled={disabled}
            aria-disabled={atCap && !on}
            onClick={() => onToggle(b.key)}
          >
            <span className={"bank-tile__cb" + (on ? " bank-tile__cb--on" : "")}>
              {on && <CheckIcon size={12} stroke="#fff" width={3.4} />}
            </span>
            {logoUrl ? (
              <span className="bank-tile__logo" style={{ backgroundImage: `url("${logoUrl}")` }} />
            ) : (
              <span className="bank-tile__logo bank-tile__logo--text">{b.name}</span>
            )}
            <span className="bank-tile__name">{b.name}</span>
          </button>
        );
      })}
    </div>
  );
}
